import type { NavigateOptions, To } from "react-router";

interface RouterLike {
  navigate(to: To, opts?: NavigateOptions): Promise<void>;
}

let router: RouterLike | null = null;

/**
 * Called once, at router creation, so code outside the React tree
 * (redux thunks, middleware) can navigate.
 */
export const registerRouter = (instance: RouterLike) => {
  router = instance;
};

/**
 * Navigate from outside a component. Inside components use `useNavigate()`.
 */
export const navigate = (to: To, opts?: NavigateOptions): void => {
  if (!router) {
    // Only reachable if a thunk fires before the router module is evaluated.
    console.error(`navigate("${String(to)}") called before the router was ready`);
    return;
  }
  void router.navigate(to, opts);
};
